export default __webpack_public_path__ + "static/media/AcceptPayments.8a4cd3b1.png";